import React from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
} from "shards-react";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import ProjectDataService from "../../services/project.service";
import { TiEdit} from "react-icons/ti";
import moment from "moment";

class ViewProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      localStoreData: [],
      localStoreFieldData: [],
      projectDetails: "",
    };
    this.state.localStoreData = JSON.parse(
      localStorage.getItem("addFormDataArr")
    );
    this.state.localStoreFieldData = JSON.parse(
      localStorage.getItem("addFieldDataArr")
    );

    this.retrieveProjectDetails = this.retrieveProjectDetails.bind(this);
  }

  componentDidMount() {
    this.retrieveProjectDetails();
  }

  componentDidUpdate(prevProps) {
    if (this.props.projectId != prevProps.projectId)
      this.retrieveProjectDetails();
  }

  retrieveProjectDetails() {
    ProjectDataService.get(this.props.projectId).then((response) => {
      this.setState({
        projectDetails: response.data.data,
      });
    });
  }

  render() {
    const { projectId } = this.props;
    const { localStoreData, projectDetails } = this.state;

    return (
      <>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Project Details</h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="projectName">Project Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        {projectDetails.projectName}
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="startDate">Start Date</label>
                      </Col>
                      <Col className="form-field" md="8">
                        {moment(new Date(projectDetails.startDate)).format(
                          "DD/MM/YYYY"
                        )}
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="countryName">Country Name</label>
                      </Col>
                      <Col className="form-field" md="8">
                        {projectDetails.countryName}
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="asset">Asset</label>
                      </Col>
                      <Col className="form-field" md="8">
                        {projectDetails.asset}
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="feFirstName">
                          File Location Configuration
                        </label>
                      </Col>
                      <Col className="form-field" md="8">
                        <div>
                          <b>Server Path : </b> {projectDetails.serverPath}
                        </div>
                        <div>
                          <b>Server Folder Path : </b>{" "}
                          {projectDetails.serverFolderPath}
                        </div>
                      </Col>
                    </Row>

                    {projectDetails.masterKeys &&
                    projectDetails.masterKeys.map(
                      (masterItem, masterIndex) => {
                        return (
                          <Row className="form-group-row" key={masterIndex + 1}>
                            <Col className="form-label" md="4">
                              <label htmlFor="feFirstName">{masterItem.masterKeyName}</label>
                            </Col>
                            <Col className="form-field" md="8">
                              <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                <Col className="form-label" md="5">
                                  Field Name
                                </Col>
                                <Col className="form-label" md="5">
                                  Data Type
                                </Col>
                                <Col className="form-label" md="2">
                                  Required
                                </Col>
                              </Row>
                              {masterItem.masterKeyFields &&
                                masterItem.masterKeyFields.map((masterFieldItem, masterFieldIndex) => {
                                  return (
                                    <Row
                                      className="form-group-row border-bottom-button ml-2 mr-2"
                                      key={masterFieldIndex + 1}
                                    >
                                      <Col className="form-field" md="5">
                                        {masterFieldItem.fieldName}
                                      </Col>
                                      <Col className="form-field" md="5">
                                        {masterFieldItem.dataType}
                                      </Col>
                                      <Col className="form-field" md="2">
                                        {masterFieldItem.isRequired === true ? "Yes" : "No"}
                                      </Col>
                                    </Row>
                                  );
                                })}
                              <Row className="form-group-row mt-3">
                                <Col className="form-label" md="3">
                                  <label htmlFor="">Has Associated Table ?</label>
                                </Col>
                                <Col className="form-field flx-items-center" md="9">
                                  {masterItem.hasAssociatedTable ? "YES" : "NO"}
                                </Col>
                              </Row>
                              {masterItem.hasAssociatedTable ? (
                                <>
                                  <Row className="form-group-row customized-01">
                                    <Col className="form-label" md="3">
                                      <label htmlFor="">Associated Table Name</label>
                                    </Col>
                                    <Col className="form-field flx-items-center" md="9">
                                      {masterItem.associatedTableName}
                                    </Col>
                                  </Row>
                                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                                    <Col className="form-label" md="5">
                                      Table Field Name
                                    </Col>
                                    <Col className="form-label" md="3">
                                      Data Type
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Required
                                    </Col>
                                    <Col className="form-label" md="2">
                                      Primary
                                    </Col>
                                  </Row>
                                  {masterItem.associatedKeyFields &&
                                    masterItem.associatedKeyFields.map((mtItem, mtIndex) => {
                                      return (
                                        <Row className="form-group-row border-bottom-button ml-2 mr-2" key={mtIndex + 1}>
                                          <Col className="form-field" md="5">
                                            {mtItem.fieldName}
                                          </Col>
                                          <Col className="form-field" md="3">
                                            {mtItem.dataType}
                                          </Col>
                                          <Col className="form-field" md="2">
                                            {mtItem.isRequired === true ? "Yes" : "No"}
                                          </Col>
                                          <Col className="form-field" md="2">
                                            {mtItem.isPrimaryKey === true ? "Yes" : "No"}
                                          </Col>
                                        </Row>
                                      );
                                    })}
                                </>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                        );
                        }
                      )}
                   
                    <Row className="form-group-row">
                      <Col className="form-field font-bold" md="12">
                        <label htmlFor="feFirstName">Required Files</label>
                      </Col>
                    </Row>
                    <Row className="form-group-row">
                      <Accordion>
                        {projectDetails.files &&
                          projectDetails.files.map((item, index) => {
                            return (
                              <Accordion.Item
                                eventKey={index + 1}
                                datakey={index + 1}
                                key={index+1}
                              >
                                <Accordion.Header>
                                  File {index + 1} - {item.fileFormat}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          File Format
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.fileFormat}
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Files Description
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.fileDescription}
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Master Api Keys
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.masterApiKeys}
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          File Naming Convention
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.fileNamingConvention}
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Maximum Number of Files
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.maxNumOfFiles}
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Mandatory Files
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.isMandatoryFile === true
                                          ? "Yes"
                                          : "No"}
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="4">
                                        <label htmlFor="feFirstName">
                                          Data Frequency By File Type
                                        </label>
                                      </Col>
                                      <Col className="form-field" md="8">
                                        {item.dataFrequencyByFileType}
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row border-bottom-button">
                                      <Col
                                        className="form-field font-bold"
                                        md="12"
                                      >
                                        <label htmlFor="feFirstName">
                                          Master Transaction Fields
                                        </label>
                                      </Col>
                                    </Row>
                                    <Row className="form-group-row border-bottom-button">
                                        <Col className="form-label" md="4">
                                            Field Name
                                        </Col>
                                        <Col className="form-label" md="4">
                                          Master key
                                        </Col>
                                        <Col className="form-label" md="4">
                                          <label htmlFor="feFirstName">
                                            Data Type
                                          </label>
                                        </Col>
                                    </Row>
                                    {item.masterTableFields &&
                                      item.masterTableFields.map(
                                        (mtItem, mtIndex) => {
                                          return (
                                            <Row className="form-group-row border-bottom-button" key={mtIndex + 1}>
                                              <Col className="form-field" md="4">
                                                {mtItem.fieldName}
                                              </Col>
                                              <Col className="form-field" md="4">
                                                {mtItem.apiKey}
                                              </Col>
                                              <Col className="form-field" md="4">
                                                {mtItem.dataType}
                                              </Col>
                                            </Row>
                                          );
                                        }
                                      )}
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                      </Accordion>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                       
                      <Row>
                          <Link className="btn btn-primary mt-2 ml-2" to={"/project/"+this.props.projectId+"/edit"}><TiEdit size="16"/> Edit Project</Link>
                      </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>
      </>
    );
  }
}

export default ViewProject;
